var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.selectedBuilding,
          expression: "selectedBuilding"
        }
      ],
      staticClass: "c-select c-select--center",
      on: {
        change: [
          function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.selectedBuilding = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
          function($event) {
            return _vm.setSelectedBuilding($event.target.value)
          }
        ]
      }
    },
    [
      _c(
        "option",
        {
          staticClass: "c-select__option",
          class: {
            "is-active": _vm.selectedBuilding === "all"
          },
          attrs: { value: "all" }
        },
        [_vm._v("\n    Oversikt\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.buildings, function(building) {
        return _c(
          "option",
          {
            key: building.id,
            staticClass: "c-select__option",
            class: {
              "is-active": building.id === _vm.selectedBuilding
            },
            domProps: { value: building.id }
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(building.name) +
                " – " +
                _vm._s(building.availability.name) +
                "\n  "
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }